'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.postRefundIfNeeded = exports.postRefundFailure = exports.postRefundSuccess = exports.postRefundRequest = exports.POST_REFUND_FAILURE = exports.POST_REFUND_SUCCESS = exports.POST_REFUND_REQUEST = undefined;

var _css = require('antd/lib/notification/style/css');

var _notification = require('antd/lib/notification');

var _notification2 = _interopRequireDefault(_notification);

var _api = require('../api');

var _order = require('./order');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 退款相关Actions
 */
var POST_REFUND_REQUEST = exports.POST_REFUND_REQUEST = 'POST_REFUND_REQUEST';
var POST_REFUND_SUCCESS = exports.POST_REFUND_SUCCESS = 'POST_REFUND_SUCCESS';
var POST_REFUND_FAILURE = exports.POST_REFUND_FAILURE = 'POST_REFUND_FAILURE';

var postRefundRequest = exports.postRefundRequest = function postRefundRequest() {
    return {
        type: POST_REFUND_REQUEST
    };
};

var postRefundSuccess = exports.postRefundSuccess = function postRefundSuccess(response) {
    return {
        type: POST_REFUND_SUCCESS,
        refund: response.data
    };
};
var postRefundFailure = exports.postRefundFailure = function postRefundFailure(error) {
    return {
        type: POST_REFUND_FAILURE,
        error: error
    };
};

var shouldPostRefund = function shouldPostRefund(state) {
    var refunds = state.refund.refunds;
    if (refunds.isPosting) {
        return false;
    }
    return true;
};

var postRefundIfNeeded = exports.postRefundIfNeeded = function postRefundIfNeeded(refundInfo) {
    return function (dispatch, getState) {
        return (0, _api.postRefund)(refundInfo).then(function (response) {
            _notification2.default['success']({
                message: '退款成功'
            });
            dispatch(postRefundSuccess(response.data));
            dispatch((0, _order.fetchOrdersIfNeeded)({}, 1));
        }).catch(function (error) {
            _notification2.default['error']({
                message: '退款失败',
                description: error.response && error.response.data && error.response.data.message
            });

            dispatch(postRefundFailure(error));
        });
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/js/actions/refund.js
// module id = 910
// module chunks = 0